import React from "react";
import { LANGUAGES } from "../../../utils/sectionTypes";

const FieldInputRenderer = ({ field, language, value, onChange }) => {
  const langMeta = LANGUAGES.find((l) => l.code === language) || LANGUAGES[0];
  const common =
    "w-full rounded-2xl border border-slate-200 bg-white px-3 py-2.5 text-sm outline-none focus:border-emerald-500 focus:ring-4 focus:ring-emerald-500/10";

  switch (field.fieldType) {
    case "textarea":
    case "rich-text":
      return (
        <textarea
          rows={4}
          dir={langMeta.dir}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          className={common}
        />
      );
    case "number":
      return (
        <input
          type="number"
          dir="ltr"
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          className={common}
        />
      );
    case "url":
    case "email":
    case "phone":
    case "text":
    default:
      return (
        <input
          type={field.fieldType === "email" ? "email" : field.fieldType === "url" ? "url" : "text"}
          dir={langMeta.dir}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          className={common}
        />
      );
  }
};

export default FieldInputRenderer;
